"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarConfigurationPanel = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var model_1 = require("../../../model");
var CreationPanel_1 = require("./CreationPanel");
/**
 * @internal
 */
exports.SidebarConfigurationPanel = function (props) {
    var configurationPanelClassName = props.configurationPanelClassName, WrapCreatePanelItemWithDragComponent = props.WrapCreatePanelItemWithDragComponent, WrapInsightListItemWithDragComponent = props.WrapInsightListItemWithDragComponent, KpiWidgetComponentSet = props.KpiWidgetComponentSet, AttributeFilterComponentSet = props.AttributeFilterComponentSet, InsightWidgetComponentSet = props.InsightWidgetComponentSet;
    var deselectWidgets = model_1.useWidgetSelection().deselectWidgets;
    var DeleteDropZoneComponent = props.DeleteDropZoneComponent;
    return (react_1.default.createElement("div", { className: "col gd-flex-item gd-sidebar-container", onClick: deselectWidgets },
        react_1.default.createElement("div", { className: "flex-panel-full-height" },
            react_1.default.createElement(CreationPanel_1.CreationPanel, { className: configurationPanelClassName, WrapCreatePanelItemWithDragComponent: WrapCreatePanelItemWithDragComponent, WrapInsightListItemWithDragComponent: WrapInsightListItemWithDragComponent, KpiWidgetComponentSet: KpiWidgetComponentSet, AttributeFilterComponentSet: AttributeFilterComponentSet, InsightWidgetComponentSet: InsightWidgetComponentSet })),
        react_1.default.createElement(DeleteDropZoneComponent, null)));
};
//# sourceMappingURL=SidebarConfigurationPanel.js.map